import { useSelector, useDispatch } from 'react-redux';
import { setPacketDetails } from '../redux/actions.js';
import config from './config.js'

const createVoidHandler = (eid, etchPacketEid, formId, dispatch, setVoidResponse, setIsVoided, setShowModal, token) => {
    return () => {
        // fetch(`http://localhost:5000/api/void/${eid}`, {
            fetch(`${config.apiBaseUrl}/void/${eid}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ voidedReason: 'User is voiding contract' }),
        })
        .then(response => {
            setVoidResponse(response.ok); // Set the void response
            if (response.ok) {
                // Show success message
                alert('Contract voided successfully');
                setIsVoided(true);
                // console.log('FormID of Void:', formId);
            } else {
                // Show error message
                alert('Failed to void contract');
            }
            // return response.json();
            return { ok: response.ok, data: response.json() }; // Return the response object
        })
        .then(({ok, data}) => {
            setShowModal(false);
            if (ok) {
                // console.log("Data on Void:", data);
            }

            // fetch(`http://localhost:5000/api/packet/${etchPacketEid}`)
            fetch(`${config.apiBaseUrl}/packet/${etchPacketEid}`)
                .then(response => {
                    if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }
                    return response.json();
                })
                .then(data => {
                    dispatch(setPacketDetails(etchPacketEid, data.data.etchPacket));
                    // console.log(data);

                    // After fetching packet details, update the form data with the etchPacketEid
                    // return fetch(`http://localhost:5000/api/formdata/${formId}`, {
                        return fetch(`${config.apiBaseUrl}/formdata/${formId}`, {
                        method: 'PUT',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${token}`
                        },
                        body: JSON.stringify({
                            etchPacketEid: etchPacketEid,
                            packetDetails: data.data.etchPacket,
                        }),
                    })
                    .then(response => {
                        if (!response.ok) {
                            throw new Error(`HTTP error! status: ${response.status}`);
                        }
                        return response.json();
                    })
                    .then(data => {
                        // console.log('Success:', data);

                        dispatch(setPacketDetails(etchPacketEid, data.packetDetails));
                    })
                    .catch(error => {
                        console.error('Error during fetch:', error);
                    });
                })
                .catch(error => {
                    console.error('Error during fetch:', error);
                });
        })
        .catch(error => {
            // Show error message
            alert('Failed to void contract end of PUT Call');
        });
    };
};

export default createVoidHandler;